import { formAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { defineStyle } from "@chakra-ui/styled-system";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  formAnatomy.keys
);

const baseStyleHelperText = defineStyle({
  position: "absolute",
  bottom: 0,
  zIndex: 3,
});

const baseStyleRequiredIndicator = defineStyle({
  color: "brand.anayltic",
});

const baseStyle = definePartsStyle({
  helperText: baseStyleHelperText,
  requiredIndicator: baseStyleRequiredIndicator,
});

export const formTheme = defineMultiStyleConfig({ baseStyle });
